import React from "react";
import { useTranslation } from "react-i18next";
import '../../css/PermissionCard.css';
import {Table, Card, Col} from "react-bootstrap"
import PropTypes from 'prop-types';

const PermissionCard = (props) => {
    const { t } = useTranslation();

    const permission = props.objPermission;

    return (
      <Col>
        <Card className="card-permission">
          <Card.Title>
            <div className="maintxt d-none">
              <div style={{backgroundColor: "#11447f"}} className="overlay-text text-white text-center p-4">{permission.role !== null ? permission.role : t('data-lang-lbl-allroles')}</div>
            </div>
          </Card.Title>
          <Card.Body style={{ paddingTop: "20px" }} className="col-xs-12">
            <Table hover={true}>
              <thead>
                <tr>
                  <th className="d-none" scope="col">{t('data-lang-lbl-contract')}</th>
                  <th className="d-none" scope="col">{t('data-lang-lbl-product')}</th>
                  <th scope="col">{t('data-lang-lbl-profile')}</th>
                </tr>
                </thead>
              <tbody>
              {permission?.data.map((item) => 
                <tr key={item.index}>
                  <td className="d-none">{item.contracts !== null ? item.contracts : t('data-lang-lbl-allcontracts')}</td>
                  <td className="d-none">{item.productName !== null ? item.productName : t('data-lang-lbl-allproducts')}</td>
                  <td>{item.authRoleName !== null ? item.authRoleName : ""}</td>
                </tr>
              )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    );
};
PermissionCard.propTypes = {
  objPermission: PropTypes.object.isRequired,
};
export default PermissionCard;



